var processInclude = require('base/util');

$(function() {
    processInclude(require('./components/miniCart'));
});